import React, { useContext, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";

import { ThemeContext, themes } from "../contexts/ThemeContext";
import { TermsContext } from "../contexts/TermsContext";
import { FavouritesContext } from "../contexts/FavouritesContext";

const Footer = ({ onToggleMeditation, isMeditationMode, onOpenFavourites, onOpenTopSongs }) => {
  const { updateTheme } = useContext(ThemeContext);
  const { setShowTerms } = useContext(TermsContext);
  const { favourites } = useContext(FavouritesContext);
  const [isFooterExpanded, setIsFooterExpanded] = useState(false);

  const handleMeditationClick = () => {
    console.log("Meditation button clicked, current mode:", isMeditationMode);
    if (onToggleMeditation) {
      onToggleMeditation();
    }
  };

  const handleSelect = (eventKey) => {
    updateTheme(eventKey);
  };

  const showTermsModal = (event) => {
    event.preventDefault();
    setShowTerms();
  };

  const openFavourites = () => {
    if (favourites.length === 0) return;
    onOpenFavourites();
  };

  const renderIcons = (dropDirection = "up") => (
    <>
      <div className="theme-button">
        <button
          className={`btn btn-moje ${isMeditationMode ? 'active' : ''}`}
          onClick={handleMeditationClick}
        >
          <i className={`fa-solid ${isMeditationMode ? 'fa-times' : 'fa-hands-praying'}`}></i>
        </button>
        {!isMeditationMode && (
          <>
            <Dropdown onSelect={handleSelect} drop={dropDirection}>
              <Dropdown.Toggle
                variant="--primary"
                className="btn-moje"
                id="dropdown-basic"
              >
                <i className="fa-solid fa-palette"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="blue">
                  <span
                    className="dot"
                    style={{ backgroundColor: themes.blue["--primary"] }}
                  ></span>
                </Dropdown.Item>
                <Dropdown.Item eventKey="yellow">
                  {" "}
                  <span
                    className="dot"
                    style={{ backgroundColor: themes.yellow["--primary"] }}
                  ></span>
                </Dropdown.Item>
                <Dropdown.Item eventKey="red">
                  {" "}
                  <span
                    className="dot"
                    style={{ backgroundColor: themes.red["--primary"] }}
                  ></span>
                </Dropdown.Item>
                <Dropdown.Item eventKey="pink">
                  {" "}
                  <span
                    className="dot"
                    style={{ backgroundColor: themes.pink["--primary"] }}
                  ></span>
                </Dropdown.Item>
                <Dropdown.Item eventKey="green">
                  {" "}
                  <span
                    className="dot"
                    style={{ backgroundColor: themes.green["--primary"] }}
                  ></span>
                </Dropdown.Item>
                <Dropdown.Item eventKey="purple">
                  {" "}
                  <span
                    className="dot"
                    style={{ backgroundColor: themes.purple["--primary"] }}
                  ></span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <button
              className="btn btn-moje"
              onClick={onOpenTopSongs}
              title="Top 50"
            >
              <i className="fa-solid fa-star"></i>
            </button>
            {favourites.length > 0 && (
              <button
                className="btn btn-moje favourites-footer-btn"
                onClick={openFavourites}
                title={`Oblíbené (${favourites.length})`}
              >
                <i className="fa-solid fa-heart"></i>
              </button>
            )}
          </>
        )}
      </div>
      <div className="copyright">
        <span className="terms">
          <button onClick={showTermsModal} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer' }} aria-label="podminky">
            <i className="fa-solid fa-circle-info"></i>
          </button>
        </span>
      </div>
    </>
  );

  if (isMeditationMode) {
    return (
      <div className="footer footer-meditation footer-meditation-only">
        <button
          className="btn btn-moje active"
          onClick={handleMeditationClick}
        >
          <i className="fa-solid fa-times"></i>
        </button>
      </div>
    );
  }

  return (
    <div className="footer">
      {/* Desktop: always visible */}
      <div className="footer-icons-wrapper footer-icons-desktop">
        {renderIcons("up")}
      </div>

      {/* Mobile: toggle button + animated sliding panel */}
      <div className="footer-mobile">
        <button
          className="btn btn-moje footer-toggle-btn"
          onClick={() => setIsFooterExpanded(!isFooterExpanded)}
        >
          <i className={`fa-solid ${isFooterExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
        </button>
        <AnimatePresence>
          {isFooterExpanded && (
            <motion.div
              className="footer-icons-wrapper footer-icons-mobile"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              {renderIcons("down")}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Footer;
